import type { SupabaseClient } from '@supabase/supabase-js'
import type { SubscribeSignatureRequestStatus } from '@/modules/auth/use-cases'

export class SupabaseSubscribeSignatureRequestStatusRepository {
  constructor(private readonly client: SupabaseClient) {}

  execute: SubscribeSignatureRequestStatus = (signatureRequestId, cb) => {
    const channel = this.client
      .channel(`signature-request-status-${signatureRequestId}`)
      .on(
        'postgres_changes',
        {
          event: 'UPDATE',
          schema: 'public',
          table: 'signature_requests',
          filter: `id=eq.${signatureRequestId}`,
        },
        () => cb(),
      )
      .subscribe((status) => {
        if (status === 'SUBSCRIBED') cb()
      })

    return () => {
      this.client.removeChannel(channel)
    }
  }
}
